import { createContext, Ref } from "react";
import { UpdateAndReturnNewLineParams } from "@components/accounting/journalEntryDrawer/JournalEntryDrawerHooks";

interface EditableTableContextState<T = any> {
    selectedArea: SelectedArea | null;
    setSelectedArea: (
        topLeftPassed: CellPosition | null,
        bottomRightPassed: CellPosition | null,
    ) => void;
    targetLines: T[];
    combineWithExistingSelectedArea: (
        topLeftPassed: CellPosition | null,
        bottomRightPassed: CellPosition | null,
    ) => void;
    bodyRef: Ref<HTMLDivElement> | null;
    headerRef: Ref<HTMLDivElement> | null;
    isInBuffer: boolean;
    setIsInBuffer: (isInBuffer: boolean) => void;
    updateAndReturnNewLine: (params: UpdateAndReturnNewLineParams<T>) => T;
}

export interface CellPosition {
    columnIndex: number;
    rowIndex: number;
}

export interface SelectedArea {
    topLeftCellPosition: CellPosition;
    bottomRightCellPosition: CellPosition;
}

export const EditableTableContext = createContext<EditableTableContextState>({
    selectedArea: null,
    setSelectedArea: () => {},
    targetLines: [],
    combineWithExistingSelectedArea: () => {},
    bodyRef: null,
    headerRef: null,
    isInBuffer: false,
    setIsInBuffer: () => {},
    updateAndReturnNewLine: (params: UpdateAndReturnNewLineParams<any>) =>
        params.line,
});
